import { DisplayCoordinateDto } from './display-coordinate.dto';
import { Rect } from './rect.type';

export class Area {
  private _coordinates: DisplayCoordinateDto;
  private _rect: Rect;

  constructor(coordinates: DisplayCoordinateDto, rect: Rect) {
    this._coordinates = coordinates;
    this._rect = rect;
  }

  get coordinates(): DisplayCoordinateDto {
    return this._coordinates;
  }

  get x(): number {
    return this._coordinates.x;
  }

  get y(): number {
    return this._coordinates.y;
  }

  get width(): number {
    return this._rect.width;
  }

  get height(): number {
    return this._rect.height;
  }
}
